import React, { useState, useRef, useEffect, useMemo, useCallback } from 'react';
import dayjs from 'dayjs';
import { Tooltip, message } from 'antd';
import { apiHolder as api, apiHolder, apis, inWindow, ProductTagEnum, AiAsstWmBizType, } from 'api';
import classnames from 'classnames';
import ReadListIcons from '@web-common/components/UI/Icons/svgs/ReadListSvgs';
import AvatarTag from '@web-common/components/UI/Avatar/avatarTag';
import TitleRightContextMenu from '@web-common/components/UI/ContextMenu/TextContextMenu';
import IconCard from '@web-common/components/UI/IconCard';
import { useAppSelector, useAppDispatch } from '@web-common/state/createStore';
import { Thunks } from '@web-common/state/reducer/mailReducer';
import ProductAuthTag from '@web-common/components/UI/ProductAuthTag/ProductAuthTag';
import CustomerLabel from '@web-mail/components/ReadMail/component/CustomerLabel';
import MailMenuIcon from '@web-mail/common/components/MailMenu/MailMenuIcon/MailMenuIcon';
import ReadMailIconMenuRightConfig from '@web-mail/common/components/MailMenu/mailMenuConifg/ReadMailIconMenuRightConfig';
import ReadMailSignMenuConfig from '@web-mail/common/components/MailMenu/mailMenuConifg/ReadMailSignMenuConfig';
import { mergeMenuConfig } from '@web-mail/common/components/MailMenu/util';
import { dateFormat, getMailAliasArr, getMailFromMails, getTreeStatesByAccount, transTag2Name, isLockTag, isFollowFolder } from '@web-mail/util';
import ItemCard from '../ItemCard';
import MailTag from '../../common/components/MailTag/MailTag';
import TimeZone from './component/TimeZone';
import styles from './index.module.scss';
import useDebounceLocalData from '../../hooks/useDebounceLocalData';
import MailDiscuss from './component/MailDiscuss/mailDiscuss';
import { MAIL_MENU_ITEM, MAIL_DISCUSS_EXCLUDE_FOLDERS, FLOLDER } from '../../common/constant';
import { copyText } from '@web-common/components/UI/ContextMenu/util';
import useState2RM from '../../hooks/useState2ReduxMock';
import { getIn18Text } from 'api';
import useCreateCallbackForEvent from '@web-mail/hooks/useCreateCallbackForEvent';
import Comment from './component/Comment/Comment';
import { useState2SubordinateSlice } from '@web-mail/hooks/useState2SliceRedux';
import PinHead from './component/PinHead/PinHead';
import { ReactComponent as QyTag } from '@/images/icons/mail/qyTag.svg';
import { ReactComponent as AIBtn } from '@/images/icons/AIBtn.svg';
import useLocalStorage from '@/hooks/useLocalStorage';
import Attachment from './component/Attachment/Attachment';
import { useChatDrawerController, ChatDrawer, useShowAiAssistant } from '@web-ai-asst-wm/components/ChatDrawer';
import { splitHTMLByRules } from '@web-common/components/UI/LxEditor/HOCAiWriteMail';
import { useGetProductAuth } from '@web-common/hooks/useGetProductAuth';
const detailShowKey = 'DETAIL_SHOW';
const trackApi = api.api.requireLogicalApi(apis.dataTrackerApiImp);
const eventApi = api.api.getEventApi();
const storeApi = api.api.getDataStoreApi();
const mailManagerApi = apiHolder.api.requireLogicalApi('mailConfApiImpl');
const htmlApi = apiHolder.api.requireLogicalApi(apis.htmlApi);
const systemApi = api.api.getSystemApi();
const mailConfApi = api.api.requireLogicalApi(apis.mailConfApiImpl);
const contactApi = api.api.requireLogicalApi(apis.contactApiImpl);
const accountApi = api.api.requireLogicalApi(apis.accountApiImpl);
const removeTagsWithDOMParser = html => {
    const parser = new DOMParser();
    const doc = parser.parseFromString(html, 'text/html');
    return doc.body.textContent;
};
const _index = ['to', 'cc', 'bcc'];
const _array = [getIn18Text('FAGEI'), getIn18Text('CHAOSONG'), getIn18Text('MISONG')];
const _detail = [getIn18Text('SHOUJIANREN1'), getIn18Text('CHAO\u3000SONG'), getIn18Text('MI\u3000SONG')];
const _oneRcpt = getIn18Text('QUNFADANXIAN');
const Header = ({ sliceId, content, isMerge = false, listData, handleDelete, menu, readOnly = false, showMailDiscuss = true, mailTagCloseAble = true, showTag = true, showTitle = true, nonAttachment = false, featureConfig, forceUpdate, }) => {
    var _a, _b, _c, _d;
    const { productVersionInfo: { navigateVersion }, } = useGetProductAuth();
    const [isShowDetail, setDetailShow] = useState(false);
    const [mid, setMid] = useState('');
    const [memo, setMemo] = useState('');
    const mailTreeStateMap = useAppSelector(state => state.mailReducer.mailTreeStateMap);
    const [showWmFUIconGuide, setShowWmFUIconGuide] = useLocalStorage('showWmFUIconGuide', true);
    const mailTagListStore = useMemo(() => {
        const folderState = getTreeStatesByAccount(mailTreeStateMap, (content === null || content === void 0 ? void 0 : content._account) || '');
        if (folderState && (folderState === null || folderState === void 0 ? void 0 : folderState.mailTagList)) {
            return folderState === null || folderState === void 0 ? void 0 : folderState.mailTagList;
        }
        return [];
    }, [mailTreeStateMap, content === null || content === void 0 ? void 0 : content._account]);
    const [mailMenuItemState, setMailMenuItemState] = useState2RM('mailMenuItemState');
    const [showAvator] = useState2RM('configMailListShowAvator', 'doUpdateConfigMailListShowAvator');
    const [selectedFolder] = useState2SubordinateSlice('selectedFolder');
    const handleDeleteRef = useCreateCallbackForEvent(handleDelete);
    const dispatch = useAppDispatch();
    const isShowWaiting = useAppSelector(state => isFollowFolder(state.mailReducer.selectedKeys.id));
    const [rightSideSelectedDetail, setRightSideSelectedDetail] = useState2RM('rightSideSelectedDetail');
    const isSendMail = useMemo(() => {
        var _a, _b, _c;
        if (content) {
            const accountAlias = ((_b = (_a = systemApi.getCurrentUser(content === null || content === void 0 ? void 0 : content._account)) === null || _a === void 0 ? void 0 : _a.prop) === null || _b === void 0 ? void 0 : _b.accountAlias) || [];
            const accountAliasArray = Array.isArray(accountAlias) ? accountAlias : [accountAlias];
            const senderEmail = contactApi.doGetModelDisplayEmail((_c = content === null || content === void 0 ? void 0 : content.sender) === null || _c === void 0 ? void 0 : _c.contact);
            return (accountAliasArray.some(account => accountApi.getIsSameSubAccountSync(account, senderEmail)) || accountApi.getIsSameSubAccountSync(senderEmail, content._account));
        }
        else {
            return false;
        }
    }, [content]);
    const localContent = useDebounceLocalData(content, {
        exception: data => { var _a, _b; return !!((_b = (_a = data === null || data === void 0 ? void 0 : data.entry) === null || _a === void 0 ? void 0 : _a.content) === null || _b === void 0 ? void 0 : _b.content); },
    });
    const domPropsRender = useCallback((mails, menuConfig) => {
        return {
            'data-test-id': 'mail-menu-readmail-head-' + (menuConfig === null || menuConfig === void 0 ? void 0 : menuConfig.key),
        };
    }, []);
    const isThreadMode = useMemo(() => {
        if (isMerge) {
            return isMerge;
        }
        const { isThread } = content || {};
        return !!isThread;
    }, [isMerge, content]);
    const [priority, setPriority] = useState();
    const [suspicious, setSuspiciousSpam] = useState(false);
    const decodeTitle = useMemo(() => {
        try {
            if (content === null || content === void 0 ? void 0 : content.entry.title) {
                const regex = /<\/?b>/g;
                const decoded = htmlApi.decodeHtml(content.entry.title.replace(regex, ''));
                return decoded;
            }
            return '';
        }
        catch (e) {
            console.error('[Error reg]', e);
            return '';
        }
    }, [content === null || content === void 0 ? void 0 : content.entry.title]);
    const keyIds = useMemo(() => {
        const { entry } = content;
        const { tid, id } = entry;
        return { tid, mid: id };
    }, [content]);
    const mailDiscussIsShow = useMemo(() => {
        const { entry } = content;
        const { folder } = entry;
        return !MAIL_DISCUSS_EXCLUDE_FOLDERS.includes(folder) && showMailDiscuss;
    }, [isThreadMode, content, showMailDiscuss]);
    useEffect(() => {
        var _a, _b, _c, _d;
        setMid((_a = localContent === null || localContent === void 0 ? void 0 : localContent.entry) === null || _a === void 0 ? void 0 : _a.id);
        setMemo(((_b = localContent === null || localContent === void 0 ? void 0 : localContent.entry) === null || _b === void 0 ? void 0 : _b.memo) || '');
        setPriority((_c = localContent === null || localContent === void 0 ? void 0 : localContent.entry) === null || _c === void 0 ? void 0 : _c.priority);
        setSuspiciousSpam(!!((_d = localContent === null || localContent === void 0 ? void 0 : localContent.entry) === null || _d === void 0 ? void 0 : _d.suspiciousSpam));
    }, [localContent]);
    const handleVisible = (visible) => {
        var _a, _b, _c, _d, _e, _f, _g, _h, _j;
        if ((process.env.BUILD_ISEDM || navigateVersion) && visible) {
            eventApi.sendSysEvent({
                eventName: 'mailMenuOper',
                eventStrData: 'headerCardVisible',
                eventData: {},
            });
        }
        if (((_a = localContent === null || localContent === void 0 ? void 0 : localContent.entry) === null || _a === void 0 ? void 0 : _a.tr_org_ec_id) && (!((_b = localContent === null || localContent === void 0 ? void 0 : localContent.entry) === null || _b === void 0 ? void 0 : _b.tr_org_ec_info) || !((_d = (_c = localContent === null || localContent === void 0 ? void 0 : localContent.entry) === null || _c === void 0 ? void 0 : _c.tr_org_ec_info) === null || _d === void 0 ? void 0 : _d.infoUrl))) {
            dispatch(Thunks.getTrOrgInfo({
                eid: (_e = localContent === null || localContent === void 0 ? void 0 : localContent.entry) === null || _e === void 0 ? void 0 : _e.tr_org_ec_id,
                mid: (_f = localContent === null || localContent === void 0 ? void 0 : localContent.entry) === null || _f === void 0 ? void 0 : _f.id,
                mail: (_j = (_h = (_g = localContent === null || localContent === void 0 ? void 0 : localContent.sender) === null || _g === void 0 ? void 0 : _g.contact) === null || _h === void 0 ? void 0 : _h.contact) === null || _j === void 0 ? void 0 : _j.accountName,
            }));
        }
    };
    const handleReceiverVisible = (visible, item) => {
        if ((process.env.BUILD_ISEDM || navigateVersion) && visible && isSendMail) {
            setRightSideSelectedDetail({ email: contactApi.doGetModelDisplayEmail(item.contact), name: (item === null || item === void 0 ? void 0 : item.originName) || '' });
        }
    };
    useEffect(() => {
        const detailShowData = storeApi.getSync(detailShowKey);
        const { data, suc } = detailShowData;
        if (suc && data === 'true') {
            setDetailShow(true);
        }
        else {
            setDetailShow(false);
        }
    }, []);
    const toogleDetailShow = (temp) => {
        setDetailShow(temp);
        storeApi.put(detailShowKey, temp ? 'true' : 'false');
    };
    useEffect(() => {
        var _a, _b, _c;
        if (inWindow() && ((_a = content === null || content === void 0 ? void 0 : content.entry) === null || _a === void 0 ? void 0 : _a.title) && ((_c = (_b = window === null || window === void 0 ? void 0 : window.location) === null || _b === void 0 ? void 0 : _b.pathname) === null || _c === void 0 ? void 0 : _c.includes('readMail'))) {
            window.document.title = getIn18Text('DUXIN-') + decodeTitle;
        }
    }, [content === null || content === void 0 ? void 0 : content.entry.title]);
    const account = (content === null || content === void 0 ? void 0 : content._account) || ((_a = systemApi.getCurrentUser()) === null || _a === void 0 ? void 0 : _a.id);
    const formatReceiver = (type, returnType) => {
        var _a;
        const showOneRcpt = [2, 3].includes((_a = content === null || content === void 0 ? void 0 : content.entry) === null || _a === void 0 ? void 0 : _a.folder) && (content === null || content === void 0 ? void 0 : content.isOneRcpt);
        const receiver = [];
        if (content && content.receiver) {
            content.receiver.forEach(item => {
                if (item.mailMemberType === type || type === 'all') {
                    const isSelected = rightSideSelectedDetail.email &&
                        isSendMail &&
                        accountApi.getIsSameSubAccountSync(rightSideSelectedDetail.email, contactApi.doGetModelDisplayEmail(item.contact));
                    if (returnType === 'nameCard') {
                        const receiverEmail = contactApi.doGetModelDisplayEmail(item.contact);
                        receiver.push(item.originName !== '无收件人' ? (receiverEmail ? (React.createElement(Tooltip, { title: receiverEmail, mouseEnterDelay: 0.5, mouseLeaveDelay: 0.1 },
                            React.createElement("span", null,
                                React.createElement(ItemCard, { contact: item.contact, showAccount: false, trigger: "click", originName: item.originName, disabled: readOnly, curAccount: account, isSelected: !!isSelected, handleVisible: visible => handleReceiverVisible(visible, item), customerLabel: process.env.BUILD_ISEDM || navigateVersion ? React.createElement(CustomerLabel, { contact: item.contact, simpleStyle: true, curAccount: account }) : null }, process.env.BUILD_ISEDM || navigateVersion ? React.createElement(CustomerLabel, { contact: item.contact, curAccount: account, simpleStyle: true }) : null)))) : (React.createElement(ItemCard, { contact: item.contact, showAccount: false, trigger: "click", originName: item.originName, disabled: readOnly, curAccount: account, isSelected: !!isSelected, handleVisible: visible => handleReceiverVisible(visible, item), customerLabel: process.env.BUILD_ISEDM || navigateVersion ? React.createElement(CustomerLabel, { contact: item.contact, simpleStyle: true, curAccount: account }) : null }, process.env.BUILD_ISEDM || navigateVersion ? React.createElement(CustomerLabel, { contact: item.contact, curAccount: account, simpleStyle: true }) : null))) : (React.createElement("div", { className: "u-card", title: item.originName, "data-test-id": 'mail-head-reveiver-' + type }, item.originName)));
                    }
                    else {
                        receiver.push(item.contactItem.contactItemVal ? (React.createElement(ItemCard, { isSelected: !!isSelected, handleVisible: visible => handleReceiverVisible(visible, item), contact: item.contact, trigger: "click", originName: item.originName, disabled: readOnly, curAccount: account, isDetail: true })) : (React.createElement("span", null, getIn18Text('WUSHOUJIANREN'))));
                    }
                }
            });
        }
        const index = _index.indexOf(type);
        const _type = returnType === 'name' ? _array[index] : _detail[index];
        return receiver.length || (type === 'to' && !returnType) ? (React.createElement("div", { className: returnType === 'name' || returnType === 'nameCard' ? 'u-info-top' : 'u-info-item' },
            React.createElement("span", { className: "name", style: {
                    width: 'auto',
                    minWidth: 56,
                } },
                showOneRcpt ? _oneRcpt : _type,
                returnType === 'name' ? '' : '：'),
            receiver.length ? (React.createElement("span", { className: "detail" }, receiver.map((_item, idx) => (React.createElement(React.Fragment, null,
                idx ? '、' : '',
                _item))))) : (React.createElement("span", { className: "detail" }, getIn18Text('WUSHOUJIANREN'))))) : ('');
    };
    const handleDeleteTag = (tagName, mailList) => {
        var _a;
        const ids = mailList.map(_ => _.entry.id);
        const account = (_a = mailList[0]) === null || _a === void 0 ? void 0 : _a._account;
        eventApi.sendSysEvent({
            eventName: 'mailTagChanged',
            eventData: {
                tagNames: [tagName],
                mailList: ids,
            },
            eventStrData: 'untag',
            _account: account,
        });
    };
    const titileRef = useRef(null);
    const [mailAliasArr, setMailAliasArr] = useState([]);
    const mailAliasArrStr = useMemo(() => mailAliasArr.join('@#@'), [mailAliasArr]);
    useEffect(() => {
        getMailAliasArr().then(arr => {
            setMailAliasArr(arr);
        });
    }, []);
    const buildResent = useCallback(() => {
        var _a, _b, _c, _d, _e, _f, _g;
        const headers = localContent === null || localContent === void 0 ? void 0 : localContent.headers;
        if (headers && headers.Sender) {
            const isReply = !!headers['Resent-From'];
            const mail = isReply ? headers['Resent-From'][0] : headers.Sender[0];
            const from = (_c = (_b = (_a = localContent === null || localContent === void 0 ? void 0 : localContent.sender) === null || _a === void 0 ? void 0 : _a.contact) === null || _b === void 0 ? void 0 : _b.contact) === null || _c === void 0 ? void 0 : _c.accountName;
            let mailSenderEmail = mail;
            if (mail === null || mail === void 0 ? void 0 : mail.includes('<')) {
                const regMail = mail.match(/\<(\S+)\>/);
                mailSenderEmail = (regMail === null || regMail === void 0 ? void 0 : regMail.length) > 1 ? regMail[1] : mailSenderEmail;
            }
            return mailSenderEmail != from ? `(由${mail}${isReply ? getIn18Text('ZHUANFA') : getIn18Text('DAIFA')})` : null;
        }
        const mailSender = ((_e = (_d = localContent === null || localContent === void 0 ? void 0 : localContent.sender) === null || _d === void 0 ? void 0 : _d.contactItem) === null || _e === void 0 ? void 0 : _e.contactItemType) === 'EMAIL' ? (_g = (_f = localContent === null || localContent === void 0 ? void 0 : localContent.sender) === null || _f === void 0 ? void 0 : _f.contactItem) === null || _g === void 0 ? void 0 : _g.contactItemVal : '';
        const _mailAliasArr = mailAliasArrStr.split('@#@');
        const isCurrentUserSend = mailSender && _mailAliasArr.indexOf(mailSender) !== -1;
        if (isCurrentUserSend && headers && headers['Original_Account']) {
            const originalAccounts = headers['Original_Account'] || [];
            if (originalAccounts && originalAccounts.length) {
                const firstAccount = originalAccounts[0];
                if (firstAccount) {
                    return getIn18Text('(BENYOUJIANY)ZHFS', { firstAccount });
                }
            }
        }
        return null;
    }, [localContent, mailAliasArrStr]);
    const receiverBody = useCallback((rType = '') => {
        var _a, _b;
        const showBcc = ((_a = content === null || content === void 0 ? void 0 : content.entry) === null || _a === void 0 ? void 0 : _a.folder) === 3;
        const showOneRcpt = [2, 3].includes((_b = content === null || content === void 0 ? void 0 : content.entry) === null || _b === void 0 ? void 0 : _b.folder) && (content === null || content === void 0 ? void 0 : content.isOneRcpt);
        return showOneRcpt ? (formatReceiver('all', rType)) : (React.createElement(React.Fragment, null,
            formatReceiver('to', rType),
            formatReceiver('cc', rType),
            showBcc ? formatReceiver('bcc', rType) : ''));
    }, [content, rightSideSelectedDetail.email]);
    const MailTagElement = useMemo(() => {
        var _a;
        const tagVisiable = !(localContent === null || localContent === void 0 ? void 0 : localContent.isTpMail) && showTag;
        return tagVisiable ? (React.createElement("div", { className: "mail-head-tag-warp", hidden: isThreadMode || !((localContent === null || localContent === void 0 ? void 0 : localContent.tags) && (localContent === null || localContent === void 0 ? void 0 : localContent.tags.length)) }, (_a = localContent === null || localContent === void 0 ? void 0 : localContent.tags) === null || _a === void 0 ? void 0 : _a.map((item, idx) => (React.createElement(MailTag, { key: idx, className: "tag", closeable: !readOnly && mailTagCloseAble && !isLockTag(item), color: mailManagerApi.getTagColor(item, true), fontColor: mailManagerApi.getTagFontColor(item), style: { color: mailManagerApi.getTagFontColor(item) }, onClose: () => {
                handleDeleteTag(item, [localContent]);
            } }, transTag2Name(item)))))) : (React.createElement(React.Fragment, null));
    }, [localContent, isThreadMode, readOnly, mailTagListStore, showTag]);
    const senderDisplayEmail = useMemo(() => {
        var _a;
        return contactApi.doGetModelDisplayEmail((_a = localContent === null || localContent === void 0 ? void 0 : localContent.sender) === null || _a === void 0 ? void 0 : _a.contact) || '';
    }, [(_b = localContent === null || localContent === void 0 ? void 0 : localContent.sender) === null || _b === void 0 ? void 0 : _b.contact]);
    const MailDetailElement = useMemo(() => {
        var _a, _b, _c, _d, _e, _f, _g;
        const timeZone = mailConfApi.getTimezone();
        const sendTime = dayjs(systemApi.getDateByTimeZone((localContent === null || localContent === void 0 ? void 0 : localContent.entry.sendTime) || 0, timeZone, true)).format('YYYY-MM-DD HH:mm:ss');
        return (React.createElement("div", { className: "u-info-detail", onClick: e => {
                e.stopPropagation();
            } },
            React.createElement("div", { className: "u-info-item" },
                React.createElement("span", { className: "title" }, getIn18Text('FAJIANREN\uFF1A')),
                React.createElement("span", { className: "content" },
                    React.createElement(ItemCard, { trInfo: (_a = localContent === null || localContent === void 0 ? void 0 : localContent.entry) === null || _a === void 0 ? void 0 : _a.tr_org_ec_info, contact: (_b = localContent === null || localContent === void 0 ? void 0 : localContent.sender) === null || _b === void 0 ? void 0 : _b.contact, originName: (_c = localContent === null || localContent === void 0 ? void 0 : localContent.sender) === null || _c === void 0 ? void 0 : _c.originName, trigger: "click", disabled: readOnly, curAccount: account, isDetail: true, handleVisible: handleVisible }),
                    ((_e = (_d = localContent === null || localContent === void 0 ? void 0 : localContent.entry) === null || _d === void 0 ? void 0 : _d.tr_org_ec_info) === null || _e === void 0 ? void 0 : _e.status) == 1 ? (React.createElement(Tooltip, { title: (_g = (_f = localContent === null || localContent === void 0 ? void 0 : localContent.entry) === null || _f === void 0 ? void 0 : _f.tr_org_ec_info) === null || _g === void 0 ? void 0 : _g.name },
                        React.createElement(QyTag, null))) : (React.createElement(React.Fragment, null, " ")))),
            React.createElement("p", { className: "u-info-item-Forward" }, buildResent()),
            receiverBody(),
            React.createElement("div", { className: "u-info-item", hidden: !isThreadMode },
                React.createElement("span", { className: "title" }, getIn18Text('ZHU&ems')),
                React.createElement("span", { className: "content" }, decodeTitle)),
            React.createElement("div", { className: "u-info-item" },
                React.createElement("span", { className: "title" }, getIn18Text('SHI&ems')),
                React.createElement("span", { className: "content" }, sendTime))));
    }, [localContent, isThreadMode, buildResent, readOnly, receiverBody]);
    const taskStatus = useAppSelector(state => state.readMailReducer.taskDetail.status);
    const customMenuConfg = useMemo(() => [
        {
            key: MAIL_MENU_ITEM.TAG,
            show: (mails, defaultShow) => {
                const mail = getMailFromMails(mails);
                const { isThread } = mail;
                if (taskStatus === 0 || isThread) {
                    return false;
                }
                return !!defaultShow ? defaultShow(mail) : false;
            },
        },
        {
            key: MAIL_MENU_ITEM.TOP,
            show: (mail, defaultShow) => {
                if (taskStatus === 0 || isThreadMode) {
                    return false;
                }
                return !!defaultShow ? defaultShow(mail) : false;
            },
        },
        {
            key: MAIL_MENU_ITEM.MOVE,
            show: (mail, defaultShow) => {
                if (isThreadMode) {
                    return false;
                }
                return !!defaultShow ? defaultShow(mail) : false;
            },
        },
        {
            key: MAIL_MENU_ITEM.MAIL_WITHDRAW,
            show: (mail, defaultShow) => {
                if (listData === null || listData === void 0 ? void 0 : listData.isrcl) {
                    return false;
                }
                return !!defaultShow ? defaultShow(mail) : false;
            },
            onClick: mails => {
                const mail = getMailFromMails(mails);
                eventApi.sendSysEvent({
                    eventName: 'mailMenuOper',
                    eventData: { mailData: mail },
                    eventStrData: 'retractEmail',
                    _account: mail === null || mail === void 0 ? void 0 : mail._account,
                });
            },
        },
        {
            key: MAIL_MENU_ITEM.MAIL_WITHDRAW_RES,
            show: (mail, defaultShow) => !!(listData === null || listData === void 0 ? void 0 : listData.isrcl) && (defaultShow ? defaultShow(mail) : false),
            onClick: mails => {
                const mail = getMailFromMails(mails);
                if (listData === null || listData === void 0 ? void 0 : listData.isrcl) {
                    eventApi.sendSysEvent({
                        eventName: 'mailMenuOper',
                        eventData: { mailData: mail, showRes: true },
                        eventStrData: 'retractEmail',
                        _account: mail === null || mail === void 0 ? void 0 : mail._account,
                    });
                }
            },
        },
        {
            key: MAIL_MENU_ITEM.DELETE,
            onClick: (mails, defaultClick) => {
                const mail = getMailFromMails(mails);
                if (handleDelete && handleDeleteRef) {
                    handleDeleteRef(mail.entry.id);
                }
                else {
                    defaultClick && defaultClick(mail);
                }
            },
        },
        {
            key: MAIL_MENU_ITEM.SHARE,
            show: (mail, defaultShow) => {
                if (mailDiscussIsShow) {
                    if (defaultShow) {
                        return defaultShow(mail);
                    }
                    return true;
                }
                return false;
            },
        },
        {
            key: MAIL_MENU_ITEM.TRANSLATE,
        },
        {
            key: MAIL_MENU_ITEM.EMAIL_HEADER,
        },
    ], [taskStatus, isThreadMode, listData === null || listData === void 0 ? void 0 : listData.isrcl, mailDiscussIsShow]);
    const chatDrawerController = useChatDrawerController();
    const showAiAssistant = useShowAiAssistant();
    const handleAI = () => {
        var _a, _b, _c, _d;
        chatDrawerController === null || chatDrawerController === void 0 ? void 0 : chatDrawerController.openChatDrawer({
            type: AiAsstWmBizType.EMAIL_SUMMARY,
            params: {
                lang: content.entry.langType || ((_a = content.entry.langListMap) === null || _a === void 0 ? void 0 : _a.originLang) || '',
                email: {
                    mid: content.id,
                    receive_time: content.entry.receiveTime,
                    receiver: ((_b = content.receiver[0]) === null || _b === void 0 ? void 0 : _b.contact.contact.accountId) || ((_c = content.receiver[0]) === null || _c === void 0 ? void 0 : _c.contact.contact.hitQueryEmail) || '',
                    receiver_name: ((_d = content.receiver[0]) === null || _d === void 0 ? void 0 : _d.originName) || '',
                    sender: content.sender.contact.contact.accountId || content.sender.contact.contact.hitQueryEmail || '',
                    sender_name: content.sender.originName || '',
                    subject: content.entry.brief || '',
                    content: removeTagsWithDOMParser(content.entry.content.content),
                },
                mid: content.id,
                quote_email_list: splitHTMLByRules(content.entry.content.content),
            },
        });
    };
    const handelIconMenuBeforeClick = useCallback((config, data) => {
        let name = config === null || config === void 0 ? void 0 : config.name;
        if (typeof (config === null || config === void 0 ? void 0 : config.name) === 'function') {
            const _name = config === null || config === void 0 ? void 0 : config.name(data);
            if (typeof _name === 'string') {
                name = _name;
            }
        }
        trackApi.track('pcMail_click_ReplyButton_mailHead_mailDetailPage', { buttonName: name });
    }, []);
    const menuConfig = useMemo(() => (menu && menu.length ? mergeMenuConfig(menu, customMenuConfg) : customMenuConfg), [menu, customMenuConfg]);
    const localMenuData = useMemo(() => (menuConfig && menuConfig.length ? mergeMenuConfig(menuConfig, ReadMailSignMenuConfig) : ReadMailSignMenuConfig), [menuConfig]);
    const mailDiscussComp = useMemo(() => React.createElement(MailDiscuss, { id: `toobar-mail-discuss${keyIds.mid}`, keyIds: keyIds }), [keyIds === null || keyIds === void 0 ? void 0 : keyIds.mid]);
    const HeaderInfoElement = useMemo(() => {
        var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o;
        return (React.createElement("div", { className: "u-item-info", style: { minHeight: 28 } },
            suspicious && (React.createElement("div", { className: "u-item-block-suspicious" },
                React.createElement(ReadListIcons.SuspiciousSvg, null))),
            typeof priority === 'number' && priority < 2 && (React.createElement(Tooltip, { title: getIn18Text('JINJIYOUJIAN'), placement: "top" },
                React.createElement("div", { className: "alarm" },
                    React.createElement(IconCard, { type: "alarm" })))),
            React.createElement("div", { className: "name" },
                React.createElement("span", { className: styles.senderEmailWrapper },
                    React.createElement(ItemCard, { trInfo: (_a = localContent === null || localContent === void 0 ? void 0 : localContent.entry) === null || _a === void 0 ? void 0 : _a.tr_org_ec_info, contact: (_b = localContent === null || localContent === void 0 ? void 0 : localContent.sender) === null || _b === void 0 ? void 0 : _b.contact, showAccount: false, originName: (_c = localContent === null || localContent === void 0 ? void 0 : localContent.sender) === null || _c === void 0 ? void 0 : _c.originName, trigger: "click", disabled: readOnly, curAccount: account, customerLabel: (process.env.BUILD_ISEDM || navigateVersion) && ((_d = localContent === null || localContent === void 0 ? void 0 : localContent.sender) === null || _d === void 0 ? void 0 : _d.contact) ? (React.createElement(CustomerLabel, { contact: (_e = localContent === null || localContent === void 0 ? void 0 : localContent.sender) === null || _e === void 0 ? void 0 : _e.contact, style: { verticalAlign: 'top', margin: '0 8px' }, curAccount: account, showEnterpriseLabel: false })) : undefined }),
                    senderDisplayEmail ? (React.createElement(React.Fragment, null,
                        React.createElement("span", { className: styles.senderEmailText },
                            "<",
                            senderDisplayEmail,
                            ">"),
                        React.createElement("span", { className: styles.senderEmailCopy, onClick: e => {
                                e.stopPropagation();
                                copyText(senderDisplayEmail);
                                message.success(getIn18Text('YIFUZHI'));
                            } }, getIn18Text('FUZHI')))) : null),
                ((_g = (_f = localContent === null || localContent === void 0 ? void 0 : localContent.entry) === null || _f === void 0 ? void 0 : _f.tr_org_ec_info) === null || _g === void 0 ? void 0 : _g.status) == 1 ? (React.createElement("span", { style: { display: 'inline-flex', alignItems: 'center', height: 20 } },
                    React.createElement(Tooltip, { title: (_j = (_h = localContent === null || localContent === void 0 ? void 0 : localContent.entry) === null || _h === void 0 ? void 0 : _h.tr_org_ec_info) === null || _j === void 0 ? void 0 : _j.name },
                        React.createElement(QyTag, null)))) : (React.createElement(React.Fragment, null, " ")),
                React.createElement("span", { className: "name-Forward" }, buildResent())),
            React.createElement("div", { className: "time", "data-test-id": "mail-head-time" }, dateFormat('YYYY-mm-dd HH:MM', ((_k = localContent === null || localContent === void 0 ? void 0 : localContent.entry) === null || _k === void 0 ? void 0 : _k.sendTime) || '')),
            ((_o = (_m = (_l = localContent === null || localContent === void 0 ? void 0 : localContent.sender) === null || _l === void 0 ? void 0 : _l.contact) === null || _m === void 0 ? void 0 : _m.contact) === null || _o === void 0 ? void 0 : _o.accountName) === 'notice@qiye.163.com' && decodeTitle.substring(0, 6) === '【账户安全】' ? (React.createElement(ProductAuthTag, { tagName: ProductTagEnum.LOGIN_DEVICE_NOTIFY, type: "bar", flowTipStyle: {
                    width: '70px',
                    padding: '0px 8px',
                    textAlign: 'center',
                    height: '20px',
                    lineHeight: '20px',
                    borderRadius: '10px',
                    backgroundColor: '#386EE7',
                    color: '#ffffff',
                } })) : (React.createElement(React.Fragment, null)),
            React.createElement("div", { style: { flex: '1' } }),
            process.env.BUILD_ISEDM && showAiAssistant && React.createElement(ChatDrawer, Object.assign({}, chatDrawerController)),
            process.env.BUILD_ISEDM && showAiAssistant && (React.createElement("div", { className: styles.AIReadBtn, onClick: handleAI },
                React.createElement(AIBtn, null),
                React.createElement("span", null, "AI\u90AE\u4EF6\u603B\u7ED3"))),
            React.createElement("div", { className: "u-operator", onClick: e => {
                    e && e.stopPropagation();
                }, hidden: readOnly, style: {
                    marginTop: showTitle ? 0 : '-4px',
                } },
                React.createElement(MailMenuIcon, { defaultMenu: ReadMailIconMenuRightConfig, beforeMenuItemClick: handelIconMenuBeforeClick, mail: content, domProps: domPropsRender, menu: [
                        {
                            key: MAIL_MENU_ITEM.SHARE,
                            show: (mail, defaultShow) => {
                                if (!isThreadMode || !showMailDiscuss || !defaultShow) {
                                    return false;
                                }
                                return defaultShow(mail);
                            },
                        },
                        {
                            key: MAIL_MENU_ITEM.TAG,
                            show: (mail, defaulShow) => {
                                if (isShowWaiting) {
                                    return false;
                                }
                                else {
                                    if (defaulShow && typeof defaulShow === 'function') {
                                        return defaulShow(mail);
                                    }
                                    return true;
                                }
                            },
                        },
                        {
                            key: MAIL_MENU_ITEM.WMFOLLOW,
                            show: () => {
                                return isShowWaiting;
                            },
                            tooltip: () => {
                                return showWmFUIconGuide ? (React.createElement("div", null,
                                    React.createElement("span", null, getIn18Text('KUAISUJIANGYJBJWYGJ')),
                                    React.createElement("span", { onClick: () => {
                                            setShowWmFUIconGuide(false);
                                        }, style: { display: 'inline-block', marginLeft: '10px', color: '#7088FF', cursor: 'pointer' } }, "\u77E5\u9053\u4E86"))) : null;
                            },
                        },
                        {
                            key: 'discuss',
                            icon: mailDiscussComp,
                            show: mailDiscussIsShow,
                        },
                        {
                            key: 'extend',
                            subMenus: localMenuData,
                        },
                    ], menuItemStateMap: mailMenuItemState, onMenuItemStateChange: (menuId, data) => {
                        var _a, _b;
                        return setMailMenuItemState(Object.assign(Object.assign({}, mailMenuItemState), { [(_a = content === null || content === void 0 ? void 0 : content.entry) === null || _a === void 0 ? void 0 : _a.id]: Object.assign(Object.assign({}, (mailMenuItemState[(_b = content === null || content === void 0 ? void 0 : content.entry) === null || _b === void 0 ? void 0 : _b.id] || {})), { [menuId]: data }) }));
                    } }))));
    }, [
        localContent,
        listData,
        buildResent,
        mid,
        readOnly,
        keyIds,
        mailDiscussIsShow,
        menu,
        mailMenuItemState,
        setMailMenuItemState,
        suspicious,
        localMenuData,
        showWmFUIconGuide,
        isShowWaiting,
        chatDrawerController,
    ]);
    const AvatarTagElement = useMemo(() => {
        var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o, _p, _q, _r, _s;
        return (React.createElement(ItemCard, { contact: (_a = content === null || content === void 0 ? void 0 : content.sender) === null || _a === void 0 ? void 0 : _a.contact, type: "avatar", trigger: "click", disabled: readOnly, originName: (_b = content === null || content === void 0 ? void 0 : content.sender) === null || _b === void 0 ? void 0 : _b.originName, trInfo: (_c = content === null || content === void 0 ? void 0 : content.entry) === null || _c === void 0 ? void 0 : _c.tr_org_ec_info, curAccount: account, handleVisible: handleVisible },
            React.createElement("div", { style: {
                    marginRight: '12px',
                    cursor: 'pointer',
                    display: 'flex',
                    alignItems: 'center',
                } },
                React.createElement(AvatarTag, { size: 32, contactId: (_f = (_e = (_d = content === null || content === void 0 ? void 0 : content.sender) === null || _d === void 0 ? void 0 : _d.contact) === null || _e === void 0 ? void 0 : _e.contact) === null || _f === void 0 ? void 0 : _f.id, propEmail: contactApi.doGetModelDisplayEmail((_g = content === null || content === void 0 ? void 0 : content.sender) === null || _g === void 0 ? void 0 : _g.contact), user: {
                        name: (_k = (_j = (_h = content === null || content === void 0 ? void 0 : content.sender) === null || _h === void 0 ? void 0 : _h.contact) === null || _j === void 0 ? void 0 : _j.contact) === null || _k === void 0 ? void 0 : _k.contactName,
                        avatar: (_o = (_m = (_l = content === null || content === void 0 ? void 0 : content.sender) === null || _l === void 0 ? void 0 : _l.contact) === null || _m === void 0 ? void 0 : _m.contact) === null || _o === void 0 ? void 0 : _o.avatar,
                        color: (_r = (_q = (_p = content === null || content === void 0 ? void 0 : content.sender) === null || _p === void 0 ? void 0 : _p.contact) === null || _q === void 0 ? void 0 : _q.contact) === null || _r === void 0 ? void 0 : _r.color,
                        email: contactApi.doGetModelDisplayEmail((_s = content === null || content === void 0 ? void 0 : content.sender) === null || _s === void 0 ? void 0 : _s.contact),
                    } }))));
    }, [content, readOnly]);
    const tpMailReadIconElement = useMemo(() => {
        var _a, _b, _c, _d;
        const contactId = (_c = (_b = (_a = content === null || content === void 0 ? void 0 : content.sender) === null || _a === void 0 ? void 0 : _a.contact) === null || _b === void 0 ? void 0 : _b.contact) === null || _c === void 0 ? void 0 : _c.id;
        const isSendMail = content.entry.folder === FLOLDER.SENT || contactId === selectedFolder.subordinateId;
        if (content.isTpMail && ((_d = content.entry) === null || _d === void 0 ? void 0 : _d.readStatus) === 'read' && !isSendMail) {
            return (React.createElement("div", { className: styles.readIcon },
                React.createElement(IconCard, { type: "tongyong_xianshi" }),
                React.createElement("span", null, getIn18Text(['XIASHU', 'YIDU']))));
        }
        else {
            return React.createElement(React.Fragment, null);
        }
    }, [content, selectedFolder]);
    return (React.createElement("div", { className: `header-box ${readOnly ? 'head-readonly' : ''}` },
        React.createElement("div", { className: "u-info" },
            React.createElement("div", { className: styles.titleWrap, style: isMerge ? { marginBottom: '16px' } : undefined },
                showTitle ? (React.createElement(TitleRightContextMenu, { targetNode: titileRef.current },
                    React.createElement("div", { ref: titileRef, className: "u-info-title", hidden: isThreadMode, "data-test-id": "mail-readmail-title" }, decodeTitle || getIn18Text('WUZHUTI')))) : (React.createElement(React.Fragment, null)),
                !isMerge ? (React.createElement("div", { className: styles.titleOperWrap },
                    React.createElement(PinHead, null))) : (React.createElement(React.Fragment, null))),
            MailTagElement,
            React.createElement("div", { className: "u-item" },
                showAvator ? AvatarTagElement : React.createElement(React.Fragment, null),
                React.createElement("div", { className: "u-item-content" },
                    HeaderInfoElement,
                    React.createElement("div", { className: "u-item-sender" },
                        React.createElement("span", { className: "detail contains no-select" }, content && ((_c = content.receiver) === null || _c === void 0 ? void 0 : _c.length) ? receiverBody('nameCard') : getIn18Text('WULIANXIREN')),
                        React.createElement("span", { className: "u-item-detail contains", style: { userSelect: 'none' }, onClick: e => {
                                e.stopPropagation();
                                toogleDetailShow(!isShowDetail);
                            }, "data-test-id": "header-detail-expand-btn" }, isShowDetail ? getIn18Text('SHOUQI') : getIn18Text('XIANGQING')))),
                tpMailReadIconElement),
            isShowDetail ? MailDetailElement : React.createElement(React.Fragment, null),
            React.createElement("div", { className: classnames({ 'header-content-attch': !isShowDetail && showAvator }) }, !nonAttachment && React.createElement(Attachment, { content: content, readOnly: readOnly, featureConfig: featureConfig, forceUpdate: forceUpdate })),
            (process.env.BUILD_ISEDM || navigateVersion) && (React.createElement(TimeZone, { contact: (_d = localContent === null || localContent === void 0 ? void 0 : localContent.sender) === null || _d === void 0 ? void 0 : _d.contact, isTpMail: !!(localContent === null || localContent === void 0 ? void 0 : localContent.isTpMail), curAccount: account, sliceId: sliceId })),
            memo && (React.createElement("div", { className: classnames(styles.commentWrap) },
                React.createElement(Comment, { memo: memo, mailId: mid, account: content === null || content === void 0 ? void 0 : content._account }))))));
};
export default Header;
